import { render, staticRenderFns } from "./notification-settings.vue?vue&type=template&id=8e1be962&scoped=true&"
import script from "./notification-settings.vue?vue&type=script&lang=js&"
export * from "./notification-settings.vue?vue&type=script&lang=js&"
import style0 from "../../../public/static/fonts.scss?vue&type=style&index=0&id=8e1be962&scoped=true&lang=scss&"
import style1 from "./notification-settings.vue?vue&type=style&index=1&id=8e1be962&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1be962",
  null
  
)

component.options.__file = "notification-settings.vue"
export default component.exports